import React__default from 'react';

const usePaginationShortcuts = ({
  setPageIndex,
  maxPageIndex,
  pageIndex,
  dangerouslyHijackGlobalKeyboardNavigation: useGlobalKeyboardNavigation
}) => {
  const onKeyDown = event => {
    if (setPageIndex && event.key === 'Home') {
      event.preventDefault();
      setPageIndex(0);
      return;
    }

    if (setPageIndex && event.key === 'End') {
      event.preventDefault();
      setPageIndex(maxPageIndex);
      return;
    }

    if (setPageIndex && event.key === 'PageUp') {
      event.preventDefault();
      setPageIndex(Math.max(0, pageIndex - 1));
      return;
    }

    if (setPageIndex && event.key === 'PageDown') {
      event.preventDefault();
      setPageIndex(Math.min(maxPageIndex, pageIndex + 1));
      return;
    }
  };

  React__default.useEffect(() => {
    if (useGlobalKeyboardNavigation) {
      window.addEventListener('keydown', onKeyDown);
    }

    return () => {
      if (useGlobalKeyboardNavigation) {
        window.removeEventListener('keydown', onKeyDown);
      }
    };
  }, [onKeyDown, useGlobalKeyboardNavigation]);
};

export { usePaginationShortcuts };
//# sourceMappingURL=usePaginationShortcuts.js.map
